<div #child>
    <ng-content></ng-content>
</div>
